import { envConfig } from "../../utils/constants";
import { StoreConfigState } from "../../utils/interfaces/storelogo";
import { client } from "../graphql";
import { GET_PAYMENT_FREQUENCY_CONFIG, GET_STORE_CONFIG } from "./queries";

class StoreConfigServices {
  async getStoreConfig(): Promise<StoreConfigState> {
    const res = await client.query({
      query: GET_STORE_CONFIG,
      context: { headers: { store: envConfig.store } },
    });
    return res.data.storeConfig;
  }

  async getPaymentFrequencyConfig(): Promise<any> {
    const res = await client.query({
      query: GET_PAYMENT_FREQUENCY_CONFIG,
      context: { headers: { store: envConfig.store } },
    });
    return res.data.storeConfig;
  }

  setStoreConfig = async (
    action: (res: any) => void,
    setLoading: (res: any) => void
  ) => {
    await this.getStoreConfig()
      .then((res: any) => {
        if (res) action(res);
        setLoading(false);
      })
      .catch((e: Error) => {
        setLoading(false);
        return e;
      });
  };

  setPaymentFrequencyConfig = async (
    action: (res: any) => void,
    setLoading: (res: any) => void
  ) => {
    await this.getPaymentFrequencyConfig()
      .then((res: any) => {
        if (res && res.__typename === "StoreConfig") {
          let paymentFrequency = {...res};
          paymentFrequency.contract_details_json = JSON.parse(res.contract_details_json || "{}");
          paymentFrequency.discount_details_json = JSON.parse(res.discount_details_json || "{}");
          action(paymentFrequency);
        }
        setLoading(false);
      })
      .catch((e: Error) => {
        setLoading(false);
        return e;
      });
  };
}

export default new StoreConfigServices();
